import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import React, { useEffect } from 'react';
import DualValueListInputClean from '../../../../../../atomic/inputs/dualValueListInput/DualValueListInputClean';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import { UnderlyingPriceExitDocumentation } from '../../../../documentation/UnderlyingPriceExitDocumentation';

export const UnderlyingPriceExitModule = ({ state }) => {
  const [
    underlyingPriceExit,
    dispatchUnderlyingPriceExit,
    ,
    setUnderlyingPriceExitEnabled,
  ] = state;

  useEffect(() => {
    setUnderlyingPriceExitEnabled(true);
  }, []);

  const currentValuesMappingFn = ({ price, qtyPct }) => {
    return { price: Number(price).toFixed(2), qtyPct: qtyPct * 100 };
  };
  const onAddFn = (inputValue1, inputValue2) => {
    const obj = { price: inputValue1, qtyPct: Number(inputValue2) / 100 };
    const arr = [...underlyingPriceExit.underlyingPricePairs, obj];
    dispatchUnderlyingPriceExit({ underlyingPricePairs: arr });
  };

  const onDeleteFn = (index) => {
    const arr = cloneDeep(underlyingPriceExit.underlyingPricePairs);
    if (arr.length === 1) {
      dispatchUnderlyingPriceExit({ underlyingPricePairs: [] });
    } else {
      arr.splice(index, 1);
      dispatchUnderlyingPriceExit({ underlyingPricePairs: arr });
    }
  };

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={UnderlyingPriceExitDocumentation} /> Underlying Price Exit
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel} style={{ gridColumn: 'span 2' }}>
          <p>
            Price | Pct. <strong>per Level</strong>
          </p>
          <DualValueListInputClean
            currentValues={underlyingPriceExit.underlyingPricePairs}
            symbol1="$"
            symbol2="%"
            direction1="left"
            direction2="right"
            currentValuesMappingFn={currentValuesMappingFn}
            onAddFn={onAddFn}
            onDeleteFn={onDeleteFn}
          />
        </div>
      </div>
    </div>
  );
};

UnderlyingPriceExitModule.propTypes = {
  state: PropTypes.any
};
